import React from 'react';

const categoryData = [
  {
    id: 1,
    name: "Lollipops",
    image: "https://res.cloudinary.com/dtivafy25/image/upload/v1753867918/Group_99_fxmrk0.png",
    link: "/lollipops"
  },
  {
    id: 2,
    name: " Candies",
    image: "https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743070908/Frame_35_1_itsi6a.png",
    link: "/candies"
  },
  {
    id: 3,
    name: "Toffees",
    image: "https://res.cloudinary.com/dzk6ng1ba/image/upload/v1744891720/Group_94_levt5f.png",
    link: "/toffees"
  },
  {
    id: 4,
    name: "Premia",
    image: "https://res.cloudinary.com/dtivafy25/image/upload/v1754481256/Group_100_lmmzhp.png",
    link: "/premia"
  }
];

const Categories = () => {
  return (
    <section className="categories-con position-relative">
      <div className="container position-relative">
        <div className="row">
          <div className="col-12">
            <div className="categories_content text-center" data-aos="fade-up">
              <h2>Explore Our <span>Delicious</span> Categories</h2>
              <p>Browse through our different categories to find your favorite ice cream treats.</p>
            </div>
          </div>
        </div>
        <div className="categories_wrapper" data-aos="fade-up">
          <div className="row">
            {categoryData.map((category) => (
              <div key={category.id} className="col-lg-3 col-md-6 col-sm-6 col-6">
                <a 
                  href={category.link} 
                  className="categories-box-link" 
                  style={{ 
                    display: 'block', 
                    textDecoration: 'none', 
                    color: 'inherit',
                    cursor: 'pointer'
                  }}
                >
                  <div className="categories-box">
                    <figure className="image mb-0">
                      <img src={category.image} alt={category.name} className="img-fluid" />
                    </figure>
                    <div className="content">
                      <h5 className="mb-0">{category.name}</h5>
                      <span className='category-icon'><i className="fa-solid fa-arrow-right"></i></span>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Categories;